import { defineStyleConfig } from "@chakra-ui/react";

export default defineStyleConfig({
  baseStyle: {
    dialog: {
      overflow: "auto",
    },
  },
});
